<template>
  <AutoComplete :suggestions="filteredSupplier" @complete="searchSupplierSite($event)" :dropdown="true"
    field="vendor_mapping" :placeholder="placeholder" v-model="supplier" forceSelection class="supplier-autocomplete"
    panelClass="supplier-panel">
    <template #item="slotProp">
      <div class="supplier-card">
        <div class="supplier-main">
          <i class="pi pi-building supplier-icon"></i>
          <span class="supplier-original">{{ slotProp.item.vendor_name }}</span>
        </div>
        <div class="supplier-sub">
          <span class="supplier-alt">{{ slotProp.item.vendor_name_alt }}</span>
          <span class="supplier-separator">•</span>
          <span class="supplier-site">
            <i class="pi pi-map-marker site-icon"></i>
            {{ slotProp.item.vendor_site_code }}
          </span>
        </div>
      </div>
    </template>
  </AutoComplete>
</template>

<script setup>
import { onMounted, ref, defineEmits, watchEffect } from 'vue';
import { getListSupplierSite } from '@/service/InvoiceProxyNonPOServices';

const filteredSupplier = ref([]);
const supplierList = ref([]);
const supplier = ref();
const placeholder = ref('Select a supplier');

// eslint-disable-next-line no-undef
const emit = defineEmits(['supplier']);

watchEffect(() => emit('supplier', supplier));

// eslint-disable-next-line no-undef
const props = defineProps({
  company: {
    type: Object,
  },
  userId: {
    type: String,
  },
});

onMounted(async () => {
  if (!props.company || !props.userId) return;

  try {
    const result = await getListSupplierSite(
      props.userId,
      props.company.db_instance,
      props.company.value,
      props.company.name
    );
    supplierList.value = result.data;
  } catch (e) {
    console.error('Failed to load supplier list:', e);
  }
});

const searchSupplierSite = (event) => {
  const query = event.query.trim();
  setTimeout(() => {
    if (!query) {
      filteredSupplier.value = [...supplierList.value];
    } else {
      const lowerQuery = query.toLowerCase();
      filteredSupplier.value = supplierList.value.filter((supp) =>
        supp.vendor_mapping.toLowerCase().includes(lowerQuery)
      );
    }
  }, 250);
};
</script>

<style scoped>
/* ─── AutoComplete wrapper ─── */
.supplier-autocomplete {
  width: 100%;
}

/* ─── Dropdown item card ─── */
.supplier-card {
  padding: 8px 10px;
  border-bottom: 1px solid #f0f2f5;
  transition: background-color 0.15s ease;
}

.supplier-card:last-child {
  border-bottom: none;
}

/* ─── Main row: icon + original name ─── */
.supplier-main {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 3px;
}

.supplier-icon {
  font-size: 0.85rem;
  color: #4a90d9;
  flex-shrink: 0;
}

.supplier-original {
  font-weight: 600;
  font-size: 0.88rem;
  color: #1a1a2e;
  line-height: 1.3;
}

/* ─── Sub row: alt name • site ─── */
.supplier-sub {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.75rem;
  color: #888;
  padding-left: 22px;
}

.supplier-alt {
  font-style: italic;
  color: #999;
}

.supplier-separator {
  color: #ccc;
  font-size: 0.5rem;
}

.supplier-site {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-weight: 500;
  color: #666;
}

.site-icon {
  font-size: 0.7rem;
  color: #e67e22;
}

/* ─── Hover effect on panel items ─── */
:deep(.p-autocomplete-panel .p-autocomplete-item) {
  padding: 0 !important;
}

:deep(.p-autocomplete-panel .p-autocomplete-item:hover .supplier-card) {
  background-color: #f5f7fa;
}

:deep(.p-autocomplete-panel .p-autocomplete-item.p-highlight .supplier-card) {
  background-color: #e8f0fe;
}
</style>
